<page-header [section]="'tools'">
  <page-title>Tools</page-title>
  <page-blurb>
    Generate hash-based message authentication codes and verify hexadecimal
    checksum codes.
  </page-blurb>
</page-header>

<div class="container-fluid my-4">
  <div class="row">
    <div class="col-12">
      <div class="card shadow rounded-4">
        <div class="card-body bg-light">
          <div class="mb-3">
            <label for="hmstr" class="form-label">String</label>
            <textarea
              class="form-control"
              id="hmstr"
              name="str"
              rows="3"
              placeholder="Enter string to hash"
              [(ngModel)]="hmacstr"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="mb-3">
            <label for="hmsec" class="form-label">Secret</label>
            <input
              class="form-control"
              id="hmsec"
              name="sec"
              placeholder="Enter secret key"
              [(ngModel)]="hmacsecret"
              autocomplete="off"
            />
          </div>
          <button class="btn btn-primary px-4" (click)="calcHmac()">
            Generate HMAC
          </button>
        </div>
        <div class="card-footer bg-white border-top border-info">
          <h6 class="fw-semibold">Sample Strings:</h6>
          <pre class="bg-light p-2 rounded border small">
[GET] https://ingv2.lacrossetechnology.com/api/v1.1/forecast/id/2CF2F7
----- body -----
          </pre>
          <pre class="bg-light p-2 rounded border small">
[POST] https://ingv2.lacrossetechnology.com/api/v1.1/gateways/wake
----- body -----
{{ '{' }}"GatewaySerial":"28000A","DisplaySerial":"28000A","Firmware":"1.1"{{ '}' }}
          </pre>
          <div *ngIf="hmac" class="alert alert-success mt-3 mb-0" role="alert">
            {{ hmac }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
